import { Progress } from '@/components/ui/progress';

interface FillIndicatorProps {
  usedVolumeCbm: number;
  maxVolumeCbm: number;
  usedWeightKg: number;
  maxWeightKg: number;
  fillPercent: number;
  compact?: boolean;
}

export function FillIndicator({
  usedVolumeCbm,
  maxVolumeCbm,
  usedWeightKg,
  maxWeightKg,
  fillPercent,
  compact,
}: FillIndicatorProps) {
  const volumePercent = maxVolumeCbm > 0 ? (usedVolumeCbm / maxVolumeCbm) * 100 : 0;
  const weightPercent = maxWeightKg > 0 ? (usedWeightKg / maxWeightKg) * 100 : 0;

  if (compact) {
    return (
      <div className="flex items-center gap-4 text-xs">
        <div className="flex items-center gap-1.5">
          <span className="text-muted-foreground">Vol:</span>
          <span className="font-medium">{volumePercent.toFixed(0)}%</span>
          <div className="w-16">
            <Progress
              value={volumePercent}
              className={`h-1.5 ${volumePercent > 90 ? '[&>div]:bg-bloqueo' : '[&>div]:bg-info'}`}
            />
          </div>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="text-muted-foreground">Peso:</span>
          <span className="font-medium">{weightPercent.toFixed(0)}%</span>
          <div className="w-16">
            <Progress
              value={weightPercent}
              className={`h-1.5 ${weightPercent > 90 ? '[&>div]:bg-bloqueo' : '[&>div]:bg-alerta'}`}
            />
          </div>
        </div>
        <span className="font-semibold">Llenado: {fillPercent.toFixed(1)}%</span>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {/* Volume bar */}
      <div>
        <div className="flex items-center justify-between text-xs mb-1">
          <span className="text-muted-foreground">Volumen (CBM)</span>
          <span className="font-medium">
            {usedVolumeCbm.toFixed(2)} / {maxVolumeCbm.toFixed(2)} ({volumePercent.toFixed(1)}%)
          </span>
        </div>
        <Progress
          value={volumePercent}
          className={`h-2 ${volumePercent > 90 ? '[&>div]:bg-bloqueo' : '[&>div]:bg-info'}`}
        />
      </div>

      {/* Weight bar */}
      <div>
        <div className="flex items-center justify-between text-xs mb-1">
          <span className="text-muted-foreground">Peso (kg)</span>
          <span className="font-medium">
            {usedWeightKg.toFixed(1)} / {maxWeightKg.toFixed(0)} ({weightPercent.toFixed(1)}%)
          </span>
        </div>
        <Progress
          value={weightPercent}
          className={`h-2 ${weightPercent > 90 ? '[&>div]:bg-bloqueo' : '[&>div]:bg-alerta'}`}
        />
      </div>

      {/* Overall fill */}
      <div className="text-center">
        <span className="text-sm font-semibold">Llenado: {fillPercent.toFixed(1)}%</span>
      </div>
    </div>
  );
}
